import { getTranslatedText } from '@nile/components';
import { isEmpty, cloneDeep } from 'lodash';

const getProcessedAttributes = (config) => {
  const { entitiesMeta, fields, intl, module } = config;
  const moduleEntity = entitiesMeta?.find((meta) => meta?.name === module);
  return fields?.map((column) => {
    if (column.indexOf('.') > -1) {
      const referredMeta = entitiesMeta?.find(
        (meta) =>
          meta.name ===
          moduleEntity?.attributes?.find((el) => {
            return el?.name === column.split('.')[0];
          })?.entity
      );
      const attribute = referredMeta?.attributes?.find(
        (el) => el.name === column.split('.')[1]
      );
      return {
        ...attribute,
        name: column,
        id: column,
        label: attribute?.attributePlaceHolder
          ? getTranslatedText(intl, attribute.attributePlaceHolder?.label)
          : null,
        isCustom: attribute?.isCustom,
        path: column
      };
    }
    const attribute = moduleEntity?.attributes?.find(
      (el) => el.name.toLowerCase() === column.toLowerCase() // TODO - remove lowercase
    );

    return {
      ...attribute,
      name: attribute?.name || 'NA',
      id: attribute?.name || 'NA',
      label:
        attribute?.label || attribute?.name
          ? getTranslatedText(intl, attribute?.label || attribute?.name)
          : '',
      isCustom: attribute?.isCustom,
      path: null
    };
  });
};

const getProcessedConfig = (config) => {
  const {
    intl,
    columnPersonalization,
    defaultColumns,
    onlyDefaultColumns,
    defaultColumnsToExclude,
    columnsOnly
  } = config;

  const processedCols = getProcessedAttributes({
    ...config,
    fields: config.allColumns
  });

  let processedDefaultCols = [];
  if (columnsOnly) {
    const trimmedcolumns = processedCols?.filter((el) => {
      return columnsOnly.includes(el.name);
    });
    const configuredColumns = getProcessedAttributes({
      ...config,
      fields: trimmedcolumns.map((el) => {
        return el.name;
      })
    });
    return {
      configuredCols: configuredColumns,
      allCols: processedCols
    };
  } else if (
    !isEmpty(columnPersonalization) &&
    onlyDefaultColumns === undefined
  ) {
    const trimmedColumnPersonalization = columnPersonalization.filter(
      (el: any) => config.allColumns.includes(el.name)
    );
    const configuredColumns = getProcessedAttributes({
      ...config,
      fields: trimmedColumnPersonalization.map((el) => {
        return el.name;
      })
    });
    return {
      configuredCols: configuredColumns,
      allCols: processedCols
    };
  } else {
    if (defaultColumns) {
      processedDefaultCols = processedCols.filter((el) => {
        return defaultColumns.includes(el.name);
      });
    }
    return {
      configuredCols:
        processedDefaultCols.length > 0
          ? defaultColumnsToExclude?.length > 0
            ? processedDefaultCols.filter((el) => {
                return !defaultColumnsToExclude.includes(el.name);
              })
            : processedDefaultCols
          : processedCols,
      allCols: processedCols
    };
  }
};

const processFilters = (conditions) => {
  let data = conditions.operands.map((operand) => {
    if (operand?.operands) {
      processFilters(operand);
    }
    switch (operand.attribute) {
      case 'client.name':
        operand.attribute = 'asset.client.name';
        break;
      case 'site.name':
        operand.attribute = 'asset.site.name';
        break;
      default:
        break;
    }
    return operand;
  });
  return data;
};

const getProcessedFilters = (filters) => {
  let processedFilters = cloneDeep(filters);

  if (!isEmpty(processedFilters)) {
    processedFilters = processFilters(filters);
  }

  return !isEmpty(processedFilters)
    ? {
        joinOperator: processedFilters[0].joinOperator,
        operands: processedFilters
      }
    : null;
};

const getUnProcessedFilters = (filters) => {
  let res = filters.operands.map((operand) => {
    if (operand?.operands) {
      getUnProcessedFilters(operand);
    }
    switch (operand.attribute) {
      case 'asset.client.name':
        operand.attribute = 'client.name';
        break;
      case 'asset.site.name':
        operand.attribute = 'site.name';
        break;
      default:
        break;
    }
    return operand;
  });
  return {
    joinOperator: filters.joinOperator,
    operands: res
  };
};

export { getProcessedConfig, getProcessedFilters, getUnProcessedFilters };
